<div class="d-flex flex-wrap">
    <div class="col-12 col-md-4">
        <h2>{{getLabel()}}</h2>
        <p>{{getDescription()}}</p>
        <div class="d-flex flex-column" *ngIf="isStepperVisible()">
            <div class="d-flex flex-column" *ngFor="let page of getPages(); let first = first; let index = index">
                <div [ngClass]="getPageStatusClasses(index)" class="page-icon-divider" *ngIf="!first">|</div>
                <div><i class="bi" [ngClass]="getPageStatusIconClasses(index)"></i><span class="bold ms-2">{{page.label}}</span></div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md">
        <form class="k-form" #wizardForm="ngForm" novalidate>
            <div class="d-flex flex-wrap">
                <div *ngFor="let element of getPageElements()" [ngSwitch]="element.type" [ngClass]="element.class">
                    <app-checkbox-element *ngSwitchCase="'checkbox'" [element]="element" [formValues]="formValues"></app-checkbox-element>
                    <app-date-input-element *ngSwitchCase="'dateInput'" [element]="element" [formValues]="formValues"></app-date-input-element>
                    <app-heading-element *ngSwitchCase="'heading'" [element]="element"></app-heading-element>
                    <app-paragraph-element *ngSwitchCase="'paragraph'" [element]="element"></app-paragraph-element>
                    <app-separator-element *ngSwitchCase="'separator'"></app-separator-element>
                    <app-text-input-element *ngSwitchCase="'textInput'" [element]="element" [formValues]="formValues"></app-text-input-element>
                    <app-masked-text-input-element *ngSwitchCase="'maskedTextInput'" [element]="element" [formValues]="formValues"></app-masked-text-input-element>
                    <app-text-area-input-element *ngSwitchCase="'textArea'" [element]="element" [formValues]="formValues"></app-text-area-input-element>
                    <app-drop-down-list-element *ngSwitchCase="'dropDownListInput'" [element]="element" [formValues]="formValues"></app-drop-down-list-element>
                    <app-select-all-element *ngSwitchCase="'selectAll'" [element]="element" [formValues]="formValues"></app-select-all-element>
                    <app-address-input-element *ngSwitchCase="'addressInput'" [element]="element" [formValues]="formValues"></app-address-input-element>
                    <app-html-element *ngSwitchCase="'html'" [element]="element"></app-html-element>
                    <div *ngSwitchCase="'empty'"></div>
                </div>
            </div>

            <div class="d-block d-md-flex mt-2">
                <!-- Mobile buttons -->
                <button kendoButton *ngIf="isNextButtonVisible()" class="d-inline-block d-md-none button-primary me-2" (click)="onNextButtonClick()" [disabled]="isNextButtonDisabled()">
                    {{getNextButtonLabel()}}
                </button>
                <button kendoButton *ngIf="isCompleteButtonVisible()" class="d-inline-block d-md-none me-2" [ngClass]="getCompleteButtonClasses()" (click)="onCompleteButtonClick()"
                    [disabled]="isCompleteButtonDisabled()">
                    {{getCompleteButtonLabel()}}
                </button>

                <button kendoButton *ngIf="isPreviousButtonVisible()" class="button-previous me-2" (click)="onPreviousButtonClick()" [disabled]="isPreviousButtonDisabled()">
                    {{getPreviousButtonLabel()}}
                </button>

                <!-- Desktop buttons -->
                <button kendoButton *ngIf="isNextButtonVisible()" class="d-none d-md-inline-block button-primary" (click)="onNextButtonClick()" [disabled]="isNextButtonDisabled()">
                    {{getNextButtonLabel()}}
                </button>
                <button kendoButton *ngIf="isCompleteButtonVisible()" class="d-none d-md-inline-block" [ngClass]="getCompleteButtonClasses()" (click)="onCompleteButtonClick()"
                    [disabled]="isCompleteButtonDisabled()">
                    {{getCompleteButtonLabel()}}
                </button>
            </div>
        </form>
    </div>
    <div class="col-12 col-md-4" *ngIf="isRightSectionVisible()" [innerHTML]="getRightSectionHtml()">
    </div>
</div>